/*
 * @Author: your name
 * @Date: 2022-04-13 10:27:24
 * @LastEditTime: 2022-04-13 10:41:19
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /privatization-webim/src/components/MockMsg/mock/feedback_1.js
 */
const feedback = {
  style: 2,
  fbKey:
        '301260a193ce53b8be5b53e2edaae6cb34a0b074e005357b96574ada2398ea8c5ccbadb73823d777c4c6ece1991980cc21ff0381c3c026ec',
  reply: {
    1: '感谢你的评价，祝你生活愉快！',
    2: '感谢你的评价，祝你生活愉快！',
    3: '感谢你的评价，祝你生活愉快！',
    4: '感谢你的评价，祝你生活愉快！',
    5: '感谢你的评价，祝你生活愉快！',
  },
  level: '5',
  seq: 1189301893,
  extUin: 2852400385,
  openTag: 1,
  extendData: {
    styleType: 1,
  },
  tags: [
    [
      { id: '452', name: '非常满意度2' },
      { id: '507', name: '学习学习' },
      { id: '458', name: '非常满意度8' },
      { id: '457', name: '非常满意度7' },
      { id: '456', name: '非常满意度6' },
      { id: '455', name: '非常满意度5' },
      { id: '454', name: '非常满意度4' },
      { id: '453', name: '非常满意度3' },
    ],
    [
      { id: '470', name: '满意10' },
      { id: '469', name: '满意9' },
      { id: '468', name: '满意8' },
      { id: '467', name: '满意7' },
      { id: '466', name: '满意6' },
      { id: '465', name: '满意5' },
      { id: '464', name: '满意4' },
      { id: '463', name: '满意3' },
      { id: '462', name: '满意2' },
      { id: '461', name: '满意1' },
    ],
    [
      { id: '480', name: '一般10' },
      { id: '479', name: '一般9' },
      { id: '478', name: '一般8' },
      { id: '477', name: '一般7' },
      { id: '476', name: '一般6' },
      { id: '475', name: '一般51' },
      { id: '471', name: '一般1' },
      { id: '472', name: '一般2' },
      { id: '473', name: '一般3' },
      { id: '474', name: '一般4' },
    ],
    [
      { id: '490', name: '不满意10' },
      { id: '488', name: '不满意8' },
      { id: '487', name: '不满意7' },
      { id: '486', name: '不满意6' },
      { id: '485', name: '不满意5' },
      { id: '489', name: '不满意9' },
      { id: '481', name: '不满意1' },
      { id: '482', name: '不满意2' },
      { id: '483', name: '不满意3' },
      { id: '484', name: '不满意4' },
    ],
    [
      { id: '500', name: '非常不满意9' },
      { id: '499', name: '非常不满意7' },
      { id: '498', name: '非常不满意8' },
      { id: '501', name: '非常不满意10' },
      { id: '497', name: '非常不满意6' },
      { id: '495', name: '非常不满意4' },
      { id: '494', name: '非常不满意3' },
      { id: '493', name: '非常不满意2' },
      { id: '491', name: '非常不满意' },
      { id: '496', name: '非常不满意5' },
    ],
  ],
  openSolve: 1,
};
export default feedback;
